/* Cargador de assets propios de Godis.

   Este archivo lo carga layout/theme.liquid en todas las paginas, asi que
   se usa para inyectar los scripts custom sin tener que tocar el layout.

   Estado actual (desde v15 - carrito de fabrica):
     - gd-enhancements.css / gd-enhancements.js quedaron NEUTRALIZADOS a
       proposito para dejar el cart drawer 100% como viene el tema original.
       No se cargan desde aqui. Los originales estan en el repo godis-v14
       (v15-neutralizados/) y en el tema 161492599038.
     - Las funciones de offset del header y del boton flotante que tenia este
       archivo tambien quedaron fuera en v15. No se restauran aqui para no
       cambiar nada mas de lo pedido.

   Lo unico que se carga es gd-pack-price.js, que corrige el precio del boton
   "Agregar al carrito" al elegir Lleva 2 / Lleva 3. */
(function () {
  'use strict';

  /* Subir este numero al cambiar gd-pack-price.js para invalidar la cache
     del navegador (la URL construida aqui no lleva el ?v= de Shopify). */
  var ASSETS_VERSION = 'gd12';

  var self = document.querySelector('script[src*="floating-elements-fix"]');
  if (!self || window.gdPackPriceLoaded) return;
  window.gdPackPriceLoaded = true;

  var base = self.src.split('?')[0].replace('floating-elements-fix.js', '');
  var script = document.createElement('script');
  script.src = base + 'gd-pack-price.js?v=' + ASSETS_VERSION;
  script.defer = true;
  document.head.appendChild(script);
})();
